module.exports = __webpack_public_path__ + "static/media/uparrow.c2f2b917.svg";